module.exports = __webpack_public_path__ + "img/product-program-phone-yszc.db0079e2.png";